<template>
  <div class="pl-chat-input flex-wrap">
    <div class="width100 flex-container align-end">
      <v-btn icon class="pl-chat-input__btn pl-chat-input__btn--attach">
        <label>
          <input id="chatInputFiles" ref="chatInputFiles" type="file" multiple @input="attachFile" />

          <div>
            <v-icon color="rgba(0,0,0,0.6)">attach_file</v-icon>
          </div>
        </label>
      </v-btn>

      <v-btn icon class="pl-chat-input__btn pl-chat-input__btn--emoji">
        <v-icon color="rgba(0,0,0,0.6)" @click="showSmiles = true"> sentiment_satisfied_alt </v-icon>

        <input-smiles
          v-show="showSmiles"
          @chooseSmile="valueMessage += $event"
          @closeSmilesWrapper="showSmiles = false"
        />
      </v-btn>

      <div class="pl-chat-input__message-area pt-1">
        <div v-show="editingMessage" class="pl-chat-input__editing flex-container align-center justify-space-between">
          <span class="pl-chat-input__editing-text"> Редактирование </span>

          <v-icon class="clear-forward-item" small @click="clearEdit"> close </v-icon>
        </div>

        <div
          v-if="activeAnswerItem && Object.keys(activeAnswerItem).length"
          class="pl-chat-input__forward-item pl-2 py-1"
        >
          <p class="mb-0 font-weight-bold">{{ activeAnswerItem.user.name }}</p>
          <p class="mb-0" v-html="activeAnswerItem.message" />

          <v-icon class="clear-forward-item" small @click="$store.commit('setActiveAnswerItem', {})"> close </v-icon>
        </div>

        <v-textarea
          v-model="valueMessage"
          class="pl-chat-input__input"
          ref="chatInput"
          rows="1"
          autofocus
          auto-grow
          filled
          @keydown="keydownHandler"
          @keyup="keyupHandler"
          @keydown.enter.prevent="keyHandler"
          @keypress="keyHandler"
          @input="setHeight"
        />

        <div
          v-if="forwardReadyMessages.length && chatIdForForward !== null"
          class="pl-chat-input__forward-item pl-2 mt-0 mb-3"
        >
          <p class="mb-0 font-weight-bold">Пересланные сообщения</p>
          <p class="mb-0">
            {{ forwardReadyMessages.length }}
            {{ formatForwardNumber }}
          </p>

          <v-icon class="clear-forward-item" small @click="$store.commit('setChatIdForForward', null)"> close </v-icon>
        </div>
      </div>

      <v-btn class="pl-chat-input__btn pl-chat-input__btn--push" color="primary" icon large @click="sendMessage()">
        <v-icon>play_arrow</v-icon>
      </v-btn>
    </div>

    <div v-if="files.length" class="pl-chat-input__files flex-container flex-wrap">
      <p class="width100">Прикрепленные файлы:</p>
      <div v-for="(file, index) in sortedMessageFiles" :key="`file_${index}`" class="file-item">
        <img v-if="file.type === 'image'" :src="file.url" class="pl-chat-input__file-img" />

        <div v-else class="flex-container align-end">
          <v-icon color="rgba(0,174,184,0.8)" size="40" @click="files.splice(index, 1)"> description </v-icon>

          <a :href="file.url" target="blank">
            {{ file.name }}
          </a>
        </div>

        <div class="pl-chat-input__delete-file flex-container align-center justify-center">
          <v-icon color="white" size="12" @click="files.splice(index, 1)"> close </v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { InputSmiles } from './ui'
import { plChatConstants } from '@/constants'
import pluralize from '@/helpers/pluralize'

export default {
  name: 'PlChatInput',
  components: {
    InputSmiles,
  },
  data() {
    return {
      tempMessages: [],
      keyControl: false,
      keyShift: false,
      keyAlt: false,
      height: 33,
      showSmiles: false,
      files: [],
    }
  },
  props: {
    activeChatId: {
      type: Number || null,
      default: null,
    },
    idSelectedUser: {
      type: Number || null,
      default: null,
    },
  },
  computed: {
    ...mapGetters(['forwardReadyMessages', 'chatIdForForward', 'activeAnswerItem']),
    valueMessage: {
      get: function () {
        if (this.activeChatId !== -1) {
          const index = this.tempMessages.findIndex(item => item.chatId === this.activeChatId)

          if (index !== -1) {
            return this.tempMessages[index].message
          } else {
            this.tempMessages.push({
              chatId: this.activeChatId,
              userId: null,
              message: '',
            })

            return this.tempMessages[this.tempMessages.length - 1].message
          }
        } else {
          const index = this.tempMessages.findIndex(item => item.userId === this.idSelectedUser)

          if (index !== -1) {
            return this.tempMessages[index].message
          } else {
            this.tempMessages.push({
              chatId: null,
              userId: this.idSelectedUser,
              message: '',
            })

            return this.tempMessages[this.tempMessages.length - 1].message
          }
        }
      },
      set: function (value) {
        let index

        if (this.activeChatId !== -1) {
          index = this.tempMessages.findIndex(item => item.chatId === this.activeChatId)
        } else {
          index = this.tempMessages.findIndex(item => item.userId === this.idSelectedUser)
        }

        this.tempMessages[index].message = value
      },
    },
    sortedMessageFiles() {
      return this.files.sort(file => {
        if (file.type === 'image') {
          return -1
        } else {
          return 1
        }
      })
    },
    formatForwardNumber() {
      return pluralize(this.forwardReadyMessages.length, ['сообщение', 'сообщения', 'сообщений'])
    },
    editingMessage() {
      // if (store.state.plChat.editMessage.id !== null) {
      //   this.editMessage();
      //   return this.messageId;
      // }
      return this.$store.getters['editMessage'].id
    },
  },
  methods: {
    keydownHandler(event) {
      if (event.key === 'Control') this.keyControl = true
      if (event.key === 'Shift') this.keyShift = true
      if (event.key === 'Alt') this.keyAlt = true
    },
    keyupHandler(event) {
      if (event.key === 'Control') this.keyControl = false
      if (event.key === 'Shift') this.keyShift = false
      if (event.key === 'Alt') this.keyAlt = false
    },
    keyHandler(event) {
      if (
        (event.key === 'Enter' && this.keyControl) ||
        (event.key === 'Enter' && this.keyShift) ||
        (event.key === 'Enter' && this.keyAlt)
      ) {
        this.valueMessage = this.valueMessage + '\n'
      } else if (event.key === 'Enter' && !this.keyControl && !this.keyShift && !this.keyAlt) {
        this.sendMessage()
      }

      this.setHeight()
    },
    clearEdit() {
      this.$store.commit('setEditMessage', {})
      this.$store.commit('setActiveAnswerItem', {})
    },
    attachFile() {
      const fileInput = document.getElementById('chatInputFiles')

      // цикл for, так как файлы не являются полноценным массивом
      // и методы, такие как forEach, работают не всегда корректно
      for (let i = 0; i < fileInput.files.length; i++) {
        const file = fileInput.files[i]

        const reader = new FileReader()
        const object = {
          url: null,
          name: file.name,
          type: null,
          fileData: file,
        }

        reader.onload = e => {
          object.url = e.target.result
          object.type = 'image'

          this.files.push(object)
        }

        if (file.type.indexOf('image') !== -1) {
          reader.readAsDataURL(file)
        } else {
          object.type = 'document'
          object.url = window.URL.createObjectURL(file)

          this.files.push(object)
        }
      }

      fileInput.value = ''
    },
    buildAttachments() {
      const attachments = [
        ...this.files.map(item => ({ ...item, type: 'file' })),
        ...this.forwardReadyMessages.map(item => ({ ...item, type: 'message' })),
      ]

      if (this.activeAnswerItem.id) {
        attachments.push({ ...this.activeAnswerItem, type: 'message' })
      }

      return attachments
    },
    async sendMessage() {
      const attachments = this.buildAttachments()

      if (this.activeChatId !== -1) {
        // Чат есть, новое сообщение.
        const index = this.tempMessages.findIndex(item => item.chatId === this.activeChatId)
        const messageText = this.preparingMessage(this.tempMessages[index].message)

        if (messageText === '' && !attachments.length) {
          this.showEmptyMessageNotify()
          return
        }

        if (this.editingMessage) {
          await this.$store.dispatch('updateMessage', {
            messageId: this.$store.getters['editMessage'].id,
            chatId: this.activeChatId,
            messageText,
            attachments,
          })
        } else {
          await this.$store.dispatch('setChatMessage', {
            chatId: this.activeChatId,
            message: messageText,
            attachments,
          })
        }

        this.tempMessages[index].message = ''
      } else {
        // Чата нет, новое сообщение.
        const index = this.tempMessages.findIndex(item => item.userId === this.idSelectedUser)
        const messageText = this.preparingMessage(this.tempMessages[index].message)

        if (messageText === '' && !attachments.length) {
          this.showEmptyMessageNotify()
          return
        }

        this.$store.commit('addMembersToChat', {
          userId: this.idSelectedUser,
          chatId: this.activeChatId,
        })

        const idNewChat = await this.$store.dispatch('createChat', this.activeChatId)

        this.$emit('set-id-active-chat', idNewChat)

        await this.$store.dispatch('setChatMessage', {
          chatId: idNewChat,
          message: messageText,
          attachments,
        })
        await this.$store.dispatch('getChatList')
        await this.$store.dispatch('getUsers', {
          reloading: false,
          limit: null,
          offset: null,
        })

        this.tempMessages[index].message = ''
      }

      this.files = []
      this.$store.commit('setActiveAnswerItem', {})
      this.setHeight()
    },
    showEmptyMessageNotify() {
      this.$notify({
        group: 'hasBottomNavigation',
        title: '',
        type: 'error',
        text: 'Сообщение должно содержать либо текст, либо вложения.',
      })
    },
    setFocus() {
      const vTextarea = document.querySelector('.pl-chat-input__input')
      const input = vTextarea.querySelector('textarea')

      input.focus()
    },
    preparingMessage(message) {
      let formattedMessage = message

      // сначала экранирование
      formattedMessage = formattedMessage.replace(
        /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gm,
        match => {
          return `<a href="${match}" target="_blank">${match}</a> `
        },
      )

      // затем замена текста смайликов на img
      plChatConstants.smiles.forEach(smile => {
        if (formattedMessage.indexOf(smile.name) !== -1) {
          const regex = new RegExp(smile.name, 'g')
          formattedMessage = formattedMessage.replace(regex, smile.text)
        }
      })

      return formattedMessage
    },
    setHeight() {
      const input = document.querySelector('.pl-chat-input__input')
      const inputSlot = document.querySelector('.pl-chat-input__input .v-input__slot')
      const inputTextarea = document.querySelector('.pl-chat-input__input textarea')
      const arrayValueMessage = this.valueMessage.split('\n')
      const height = arrayValueMessage.length > 1 ? 33 + (arrayValueMessage.length - 1) * 18 : 33

      inputTextarea.style.height = `${height}px`
      input.style.height = `${height + 18}px`
      inputSlot.style.height = `${height}px`
    },
  },
  watch: {
    activeChatId: function () {
      this.files = []
      this.setFocus()
    },
    idSelectedUser: function () {
      this.setFocus()
    },
    editingMessage(val) {
      if (val) {
        let formattedMessage = this.$store.getters['editMessage'].message

        plChatConstants.smiles.forEach(smile => {
          if (formattedMessage.indexOf(smile.text) !== -1) {
            const regex = new RegExp(smile.text, 'g')
            formattedMessage = formattedMessage.replace(regex, smile.name)
          }
        })

        this.valueMessage = formattedMessage
        this.files = this.$store.getters['editMessage'].files.map(file => ({
          url: file.url,
          name: file.originName,
          type: file.type,
          id: file.id,
        }))
        this.attachments = this.$store.getters['editMessage'].attachments
        this.setFocus()
      } else {
        this.valueMessage = ''
        this.attachments = []
        this.files = []
      }
    },
  },
}
</script>

<style lang="scss">
.pl-chat-input {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.4);
  background-color: rgba(0, 0, 0, 0.04);

  & .v-textarea textarea {
    background-color: white;
    padding: 7px 0.5rem 8px;
  }

  &__btn {
    flex: 0 0 auto;
    margin: 10px 8px;

    &--push {
      margin: 6px 8px;
    }

    &--attach {
      label input {
        display: none;
      }
    }
  }

  &__input {
    flex: 1 1 auto;
    height: auto !important;
    max-height: 200px;
    overflow-y: auto;
    margin: 3px 0;
  }

  &__message-area {
    flex: 1 0 auto;
    padding: 0 1rem;
  }

  &__forward-item {
    position: relative;
    margin-top: 5px;
    border-left: 2px solid rgba(0, 174, 184, 0.5);

    .clear-forward-item {
      position: absolute;
      top: calc(50% - 5px);
      right: 20px;
    }
  }

  &__files {
    padding: 0 20px 20px;

    .file-item {
      position: relative;
      margin-right: 10px;
    }
  }

  &__delete-file {
    position: absolute;
    width: 15px;
    height: 15px;
    background-color: rgba(0, 0, 0, 0.6);
    top: 0;
    right: 0;
  }

  &__file-img {
    width: 60px;
    height: 60px;
  }
}
</style>
